import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox, SectionTitle, SelectControllerVertical } from "@components";
import { TableColumn } from "./TableColumn";

import { useAssetList } from "@hooks/inventory/requisition/useAssetList";
import { useMetaData } from "@hooks/inventory/settings/useMetaData";

import { getConvertedMetaData } from "@helpers/inventory/metaDataConvert";
import { TablePagination } from "@helpers/tablePagination";

import { AssetResponseType } from "@type/inventory/asset";
import { Pagination } from "@type/inventory/pagination";

import { SETTINGS_META_DATA } from "@constants/inventory/settings-meta-data";

const { GROUP, BRAND } = SETTINGS_META_DATA;

function SelectProductTable({ selectProduct, selectedAssets }: any) {
  const { t } = useTranslation();
  const { control, setValue, register } = useForm();

  const { data: groups } = useMetaData(GROUP);
  const { data: brands } = useMetaData(BRAND);

  const { handleQuery, assetState } = useAssetList();
  const { getData, createSuccess, deleteSuccess } = assetState;

  const { data, pagination } = getData || ({} as AssetResponseType);
  const { page } = pagination || ({} as Pagination);

  useEffect(() => {
    if (createSuccess === true) handleQuery("page", 1);
    else if (deleteSuccess === true) handleQuery("page", page);
  }, [createSuccess, deleteSuccess]);

  return (
    <div className="my-10">
      <SectionTitle label="INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TITLE" />
      <Table
        columns={TableColumn(t, selectProduct, selectedAssets) as any}
        rows={data || []}
        headerExtension={{
          leftComponents: [
            <div className="row pb-0 mb-0">
              <SelectControllerVertical
                label="INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_DROPDOWN.GROUP"
                name="group"
                register={{ ...register("group") }}
                options={getConvertedMetaData(groups)}
                setValue={setValue}
                selectAction={(e) => handleQuery("groupId", e)}
                control={control}
                cols={6}
                portal
                withoutLabel
              />
              <SelectControllerVertical
                label="INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_DROPDOWN.BRAND"
                name="brand"
                register={{ ...register("brand") }}
                options={getConvertedMetaData(brands)}
                setValue={setValue}
                selectAction={(e) => handleQuery("brandId", e)}
                control={control}
                cols={6}
                portal
                withoutLabel
              />
            </div>,
          ],
          rightComponents: [
            <SearchBox
              key="search"
              control={control}
              handleQuery={handleQuery}
              placeholder="INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.SEARCH"
            />,
          ],
        }}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}

export default SelectProductTable;
